export default __webpack_public_path__ + "static/media/eyeopening.e477eac8.gif";